import axios from '@/axios'

const actions = {
  setFights: ({ dispatch, commit }, payload = {}) => {
    // `silent` permite o auto-refresh da agenda sem piscar o overlay global
    // de loading. Removido do corpo antes de ir pro backend (que só lê event_id).
    const { silent, ...query } = payload
    if (!silent) dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .getFromEvent(query)
      .then((response) => {
        commit('fights', response)
        if (!silent) dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        if (!silent) dispatch('main/setLoading', false, { root: true })
      })
  },

  setInitFight: ({ commit, dispatch }, ids) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .initFight(ids)
      .then((response) => {
        commit('currentFight', response)
        dispatch('main/setLoading', false, { root: true })
        return response // devolve a luta p/ o caller navegar só após carregar
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },

  setInfoJudgeScoreFight: ({ commit, dispatch }, fightId) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .infoJudgesScoresFight(fightId)
      .then((response) => {
        commit('infoJudgesScoresFight', response)
        return dispatch('main/setLoading', false, { root: true })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },

  setFinishFight: ({ commit, dispatch }, fightId) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .finishFight(fightId)
      .then((response) => {
        return dispatch('main/setLoading', false, { root: true })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },

  setEnterFight: ({ commit, dispatch }, ids) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .enterFight(ids)
      .then((response) => {
        commit('currentFight', response)
        dispatch('main/setLoading', false, { root: true })
        return response // devolve a luta p/ o caller navegar só após carregar
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },

  setEnterRoundJudgeFight: ({ commit, dispatch }, ids) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .enterRoundJudgeFight(ids)
      .then((response) => {
        commit('currentFight', response)
        dispatch('main/setLoading', false, { root: true })
        return response // devolve a luta p/ o caller navegar só após carregar
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },

  setGenerateKeys: ({ commit, dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .generateKeys(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response // sucesso: devolve o resultado p/ o caller decidir refetch
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return false // falha: caller NAO deve recarregar a chave (evita sobrescrever com vazio)
      })
  },

  setfightAggressivity: ({ commit, dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .fightAggressivity(info)
      .then((response) => {
        return dispatch('main/setLoading', false, { root: true })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },

  setFightDamage: ({ commit, dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .fightDamage(info)
      .then((response) => {
        return dispatch('main/setLoading', false, { root: true })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },

  setCategoryKeys: ({ commit, dispatch }, ids) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .categoryKeys(ids)
      .then((response) => {
        commit('currentKeys', response)
        return dispatch('main/setLoading', false, { root: true })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },

  setChangeFightsTime: ({ dispatch }, fights) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .changeFightsTime(fights)
      .then((response) => {
        return dispatch('main/setLoading', false, { root: true })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },

  // Reagendar tudo: a próxima luta pendente passa pro novo horário e as demais
  // acompanham (delta uniforme no servidor). Devolve o resultado (ou null em
  // erro) pro caller decidir o feedback.
  setReschedulePending: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .reschedulePending(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        // devolve o corpo do erro (400/409 têm mensagem específica do backend)
        return (error.response && error.response.data) || null
      })
  },

  setScheduleFights: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .scheduleFights(info)
      .then((response) => {
        dispatch('main/setLoading', false, { root: true })
        return response
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
        return null
      })
  },

  setJudgeDecision: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios
      .fights
      .post
      .judgeDecision(info)
      .then((response) => {
        return dispatch('main/setLoading', false, { root: true })
      })
      .catch(function (error) {
        console.log('-----------error-----------', error)
        dispatch('main/setLoading', false, { root: true })
      })
  },

  setCleanCurrentFight: ({ commit, dispatch }) =>
    // [] (não {}): o estado/consumidores tratam currentFight como array
    // (getCurrentFight.find/.length). Comitar {} quebrava doSetAction.
    commit('currentFight', []),

  // —— Fase de grupos ————————————————————————————————————————————————————

  fetchGroupStage: ({ dispatch }, ids) => {
    return axios.fights.post.getGroupStage(ids)
      .then((response) => response)
      .catch((error) => { console.log('-----------error-----------', error); return null })
  },

  fetchGroupStandings: ({ dispatch }, ids) => {
    return axios.fights.post.getGroupStandings(ids)
      .then((response) => response)
      .catch((error) => { console.log('-----------error-----------', error); return null })
  },

  setGroupStageEnabled: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios.fights.post.setGroupStage(info)
      .then((response) => { dispatch('main/setLoading', false, { root: true }); return response })
      .catch((error) => { console.log('-----------error-----------', error); dispatch('main/setLoading', false, { root: true }); return null })
  },

  setGenerateGroups: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios.fights.post.generateGroups(info)
      .then((response) => { dispatch('main/setLoading', false, { root: true }); return response })
      .catch((error) => { console.log('-----------error-----------', error); dispatch('main/setLoading', false, { root: true }); return null })
  },

  fetchEventLunch: (context, info) => {
    return axios.fights.post.getEventLunch(info)
      .then((response) => response)
      .catch(() => null)
  },

  fetchGroupPlan: ({ dispatch }, info) => {
    return axios.fights.post.getGroupPlan(info)
      .then((response) => response)
      .catch((error) => { console.log('-----------error-----------', error); return null })
  },

  setGroupsComposition: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios.fights.post.setGroups(info)
      .then((response) => { dispatch('main/setLoading', false, { root: true }); return response })
      .catch((error) => { console.log('-----------error-----------', error); dispatch('main/setLoading', false, { root: true }); return null })
  },

  setGenerateBracketFromGroups: ({ dispatch }, info) => {
    dispatch('main/setLoading', true, { root: true })
    return axios.fights.post.generateBracketFromGroups(info)
      .then((response) => { dispatch('main/setLoading', false, { root: true }); return response })
      .catch((error) => { console.log('-----------error-----------', error); dispatch('main/setLoading', false, { root: true }); return null })
  }
}

export default actions
